import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Button, DialogConfirm } from 'components'
import { toast } from 'react-toastify'
import { TextField } from '@mui/material'
import { cloneDeep } from 'lodash'
import { useSelector } from 'react-redux'
import { submitExtraAutoAnswer } from 'services/apiKYP'
import AddAttachments from 'components/AddAttachments'
import { removeAttachment } from 'utils/attachmentOperations'

import styles from './styles'

const initialValues = {
  facts_about_inclusion: '',
  occurrence_summary: '',
  adopted_approaches: '',
  attachments: [],
  answer_type: 'restriction_list',
}

const initialErrors = {
  facts_about_inclusion: false,
  occurrence_summary: false,
  adopted_approaches: false,
}

function RestrictiveListForm(props) {
  const { questionData } = props

  const token = useSelector((state) => state.auth.access_token)
  const classes = styles()

  const [formState, setFormState] = useState(initialValues)
  const [formErrors, setFormErrors] = useState(initialErrors)
  const [loading, setLoading] = useState(false)
  const [open, setOpen] = useState(false)

  const handleValidate = () => {
    const errors = cloneDeep(initialErrors)
    Object.keys(errors).forEach((key) => {
      errors[key] = formState[key] === ''
    })
    setFormErrors(errors)
    return Object.keys(errors).every((key) => errors[key] === false)
  }

  const cleanForm = () => {
    setFormState(initialValues)
    setFormErrors(initialErrors)
  }

  const handleSubmit = async () => {
    if (handleValidate()) {
      setLoading(true)
      submitExtraAutoAnswer(token, questionData.uuid, formState)
        .then(() => {
          toast.success('Resposta enviada com sucesso')
          cleanForm()
        })
        .catch(() => {
          toast.error('Erro ao enviar respostas, por favor tente novamente')
        })
        .finally(() => {
          setLoading(false)
        })
    } else {
      toast.error(
        'Há campos obrigatórios vazios. Verifique os campos preenchidos e tente novamente.',
      )
    }
  }

  const handleCleanAction = () => {
    setOpen(false)
    const attachments = cloneDeep(formState.attachments)
    if (attachments.length > 0) {
      Promise.all(
        attachments.map((attachment) =>
          removeAttachment(attachment.uuid, token),
        ),
      )
    }
    cleanForm()
  }

  const handleFieldChange = (event) => {
    const newFormState = cloneDeep(formState)
    const key = event.target.id
    newFormState[key] = event.target.value
    setFormState(newFormState)
  }

  const handleUpdateAttachments = (attachmentsList) => {
    const newFormState = cloneDeep(formState)
    newFormState.attachments = attachmentsList
    setFormState(newFormState)
  }
  
  const handleOpenConfirmCleaning = () => {
    setOpen(true)
  }
  
  const handleCloseConfirmCleaning = () => {
    setOpen(false)
  }

  return (
    <div className={classes.root}>
      <h2>Lista Restritiva</h2>
      <div className={classes.formWrapper}>
        <div className={classes.subject}>
          <p>
            <span>Nome da lista: </span>
            {questionData.occurrence.list_name}
          </p>
        </div>
        <TextField
          id="facts_about_inclusion"
          label="Fatos envolvidos na inclusão em lista restritiva:"
          onChange={handleFieldChange}
          fullWidth
          value={formState.facts_about_inclusion}
          error={formErrors.facts_about_inclusion}
          InputLabelProps={{ shrink: true }}
          size="small"
        />
        <TextField
          id="occurrence_summary"
          label="Breve relato sobre o ocorrido:"
          onChange={handleFieldChange}
          fullWidth
          multiline
          minRows={3}
          value={formState.occurrence_summary}
          error={formErrors.occurrence_summary}
          InputLabelProps={{ shrink: true }}
          size="small"
        />
        <TextField
          id="adopted_approaches"
          label="Tratativas adotadas para a situação:"
          onChange={handleFieldChange}
          fullWidth
          multiline
          minRows={3}
          value={formState.adopted_approaches}
          error={formErrors.adopted_approaches}
          InputLabelProps={{ shrink: true }}
          size="small"
        />
        <AddAttachments
          title="Anexe um resumo da ocorrencia, bem como o processo administrativo, se houver."
          attachments={formState.attachments}
          updateAttachments={handleUpdateAttachments}
        />
        <div className={classes.buttonsContainer}>
          <Button onClick={handleOpenConfirmCleaning} variant="text">
            Limpar formulário
          </Button>
          <Button onClick={handleSubmit} loading={loading}>
            Responder
          </Button>
        </div>
      </div>
      <DialogConfirm 
        title='Tem certeza de que deseja limpar este formulário?'
        onConfirm={handleCleanAction}
        onCancel={handleCloseConfirmCleaning}
        open={open}
      >
        Esta ação é irreversível e não poderá ser desfeita.
      </DialogConfirm>
    </div>
  )
}

RestrictiveListForm.propTypes = {
  questionData: PropTypes.shape({
    uuid: PropTypes.string.isRequired,
    text: PropTypes.string,
    occurrence: PropTypes.object,
    answered: PropTypes.bool.isRequired,
    subject: PropTypes.string.isRequired,
    answer: PropTypes.object,
  }).isRequired,
}

export default RestrictiveListForm
